import { Injectable } from '@angular/core';
import product_data from '@/data/product-data';
import { IProduct } from '@/types/product-type';
import { ProductService } from './product.service';
import { CartService } from './cart.service';
import { NavigationEnd, Router } from '@angular/router';
import moment from 'moment';
import { ProfilesService } from '@viewbid/ts-angular-client';
import { Observable, of } from 'rxjs';
import { User } from 'viewbid-shared-lib';
import { VbSnackbarService } from '@viewbid/ui';

@Injectable({
    providedIn: 'root',
})
export class UtilsService {
    res: number | undefined;
    constructor(
        private productService: ProductService,
        private cartService: CartService,
        private router: Router,
        private profileService: ProfilesService,
        private snackbarService: VbSnackbarService,
    ) {
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.isSearchOpen = false;
                this.isProductModalOpen = false;
                this.openMobileMenus = false;
                this.removeBackdropAndProductModal();
            }
        });
    }

    // video modal
    public videoUrl = 'https://www.youtube.com/embed/EW4ZYb3mCZk';
    public isVideoOpen = false;
    public isSearchOpen = false;
    public isProductModalOpen = false;
    public openMobileMenus = false;
    public iframeElement: HTMLIFrameElement | null = null;
    // product modal
    public modalId = 'product-modal-641e887d05f9ee1717e1348a';
    public product: IProduct = product_data[0];

    // open mobile sidebar
    handleOpenMobileMenu(): void {
        this.openMobileMenus = !this.openMobileMenus;
    }

    // modal video play
    playVideo(videoId: string): void {
        const videoOverlay: Element | null =
            document.querySelector('#video-overlay');
        this.videoUrl = `https://www.youtube.com/embed/${videoId}`;
        if (!this.iframeElement) {
            this.iframeElement = document.createElement('iframe');
            this.iframeElement.setAttribute('src', this.videoUrl);
            this.iframeElement.style.width = '60%';
            this.iframeElement.style.height = '80%';
        }

        this.isVideoOpen = true;
        videoOverlay?.classList.add('open');
        videoOverlay?.appendChild(this.iframeElement);
    }
    // close modal video
    closeVideo(): void {
        const videoOverlay: Element | null = document.querySelector(
            '#video-overlay.open',
        );

        if (this.iframeElement) {
            this.iframeElement.remove();
            this.iframeElement = null;
        }

        this.isVideoOpen = false;
        videoOverlay?.classList.remove('open');
    }

    handleSearchOpen(): void {
        this.isSearchOpen = !this.isSearchOpen;
    }

    // handle Open Modal
    handleOpenModal(id: string, item: IProduct): void {
        this.isProductModalOpen = true;
        this.modalId = id;
        this.product = item;
        this.productService.handleImageActive(item.img);
        this.cartService.initialOrderQuantity();
    }

    removeBackdropAndProductModal(): void {
        const modalBackdrop: Element | null =
            document.querySelector('.modal-backdrop');
        const product_modal: HTMLElement = document.querySelector(
            '.tp-product-modal.show',
        ) as HTMLElement;
        if (modalBackdrop) {
            modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.removeAttribute('style');
        }
        if (product_modal) {
            product_modal.style.display = 'none';
        }
    }

    // Method to parse date string into formatted date
    public parseDate(dateString?: string, fromFormat?: string): string {
        if (!fromFormat) {
            fromFormat = 'MM/DD/YYYY, h:mm:ss a';
        }
        if (!dateString) {
            return 'Not a valid date';
        }
        return moment.utc(dateString).local().format(fromFormat);
    }

    // Get time remaining from date string
    public getTimeRemaining(dateString?: string, expanded?: boolean): string {
        if (!dateString) {
            return 'Not a valid date';
        }
        // Parse the date string into a moment object
        const date: moment.Moment = moment(dateString, 'YYYY-MM-DD, h:mm:ss a');

        // Get the current moment
        const now: moment.Moment = moment();

        // Calculate the difference in milliseconds
        const diff: number = date.diff(now);

        // Convert the difference to days and hours
        const days: number = moment.duration(diff).days();
        const hours: number = moment.duration(diff).hours();

        // Display the result
        if (expanded) {
            return `${days} Day(s) ${hours} Hour(s)`;
        } else {
            return `${days}d ${hours}h`;
        }
    }

    public isProfileCreated(user: User): Observable<boolean> {
        return of(!!user.accountMappingsId);
    }
}
